import RichTextMenuItemsService from './rich-text-menu-items-service';

import StrikeSvg from './menu-items/assets/StrikeSvg';
import UnderlineSvg from './menu-items/assets/UnderlineSvg.vue';
import ItalicSvg from './menu-items/assets/ItalicSvg';
import BulletListSvg from './menu-items/assets/BulletListSvg';
import OrderedListSvg from './menu-items/assets/OrderedListSvg';

import FontSizeFormatting from './menu-items/FontSizeFormatting';
import FontColorFormatting from './menu-items/FontColorFormatting';
import BoldFormatting from './menu-items/BoldFormatting';
import TextAlignLeftFormatting from './menu-items/TextAlignLeftFormatting';
import TextAlignCenterFormatting from './menu-items/TextAlignCenterFormatting';
import TextAlignRightFormatting from './menu-items/TextAlignRightFormatting';
import LinkFormatting from './menu-items/LinkFormatting';
import ImageFormatting from './menu-items/ImageFormatting';
import TextToConfigurationFieldFormatting from './menu-items/TextToConfigurationFieldFormatting';

export const FONT_SIZE = 'FONT_SIZE';
export const FONT_COLOR = 'FONT_COLOR';
export const BOLD = 'BOLD';
export const STRIKE = 'STRIKE';
export const UNDERLINE = 'UNDERLINE';
export const ITALIC = 'ITALIC';
export const BULLET_LIST = 'BULLET_LIST';
export const ORDERED_LIST = 'ORDERED_LIST';
export const TEXT_ALIGN_LEFT = 'TEXT_ALIGN_LEFT';
export const TEXT_ALIGN_CENTER = 'TEXT_ALIGN_CENTER';
export const TEXT_ALIGN_RIGHT = 'TEXT_ALIGN_RIGHT';
export const LINK = 'LINK';
export const IMAGE_FORMATTING = 'IMAGE_FORMATTING';
export const TEXT_TO_CONFIGURATION_FIELD = 'TEXT_TO_CONFIGURATION_FIELD';

const { fromExtentionToSimpleMenuItemHOF } = RichTextMenuItemsService;
export const RICH_TEXT_MENU_BUTTONS = {
	[FONT_SIZE]: {
		menuComponent: FontSizeFormatting,
	},
	[FONT_COLOR]: {
		menuComponent: FontColorFormatting,
	},
	[BOLD]: {
		menuComponent: BoldFormatting,
	},
	[STRIKE]: {
		menuComponent: fromExtentionToSimpleMenuItemHOF(StrikeSvg, 'strike', 'toggleStrike'),
	},
	[UNDERLINE]: {
		menuComponent: fromExtentionToSimpleMenuItemHOF(UnderlineSvg, 'underline', 'toggleUnderline'),
	},
	[ITALIC]: {
		menuComponent: fromExtentionToSimpleMenuItemHOF(ItalicSvg, 'italic', 'toggleItalic'),
	},
	[BULLET_LIST]: {
		menuComponent: fromExtentionToSimpleMenuItemHOF(BulletListSvg, 'bulletList', 'toggleBulletList'),
	},
	[ORDERED_LIST]: {
		menuComponent: fromExtentionToSimpleMenuItemHOF(OrderedListSvg, 'orderedList', 'toggleOrderedList'),
	},
	[TEXT_ALIGN_LEFT]: {
		menuComponent: TextAlignLeftFormatting,
	},
	[TEXT_ALIGN_CENTER]: {
		menuComponent: TextAlignCenterFormatting,
	},
	[TEXT_ALIGN_RIGHT]: {
		menuComponent: TextAlignRightFormatting,
	},
	[LINK]: {
		menuComponent: LinkFormatting,
	},
	[IMAGE_FORMATTING]: {
		menuComponent: ImageFormatting,
	},
	[TEXT_TO_CONFIGURATION_FIELD]: {
		menuComponent: TextToConfigurationFieldFormatting,
	},
};

export const MARKDOWN_MENU_BUTTONS_KEYS = [FONT_SIZE, FONT_COLOR];

export const HTML_MENU_BUTTONS_KEYS = [
	BOLD,
	STRIKE,
	UNDERLINE,
	ITALIC,
	BULLET_LIST,
	ORDERED_LIST,
	TEXT_ALIGN_LEFT,
	TEXT_ALIGN_CENTER,
	TEXT_ALIGN_RIGHT,
	LINK,
	IMAGE_FORMATTING,
];

export const TEXT_MENU_BUTTONS_KEYS = [TEXT_TO_CONFIGURATION_FIELD];
